import {
  CardWithAreaLine,
  CollapsibleCard
} from '@yes.technology/react-toolkit'
import styled, { css } from 'styled-components'
import { FilterButton } from '../../FilterFields.styles'

export const StyledCardWithAreaLine = styled(CardWithAreaLine)<{
  backgroundColor?: string
  color?: string
  disabled?: boolean
}>``

export const StyledCollapsibleCard = styled(CollapsibleCard)<{
  $emptyRight?: boolean
}>`
  & > :first-child {
    nav {
      padding: 4px 16px;

      @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
        height: 100%;
        padding: 12px 16px;
      }
    }

    nav > div:first-child > div:first-child {
      @media (min-width: ${({ theme }) =>
          theme.breakpoints.md}px) and (max-width: 991px) {
        flex-basis: 100%;
      }
    }

    nav > div:last-child {
      @media (min-width: ${({ theme }) =>
          theme.breakpoints.md}px) and (max-width: 991px) {
        align-self: unset;
        margin-top: 10px;
      }
    }

    ${({ $emptyRight, theme }) =>
      $emptyRight &&
      css`
        & div:has(> [data-group-controls-center]) {
          @media (min-width: ${theme.breakpoints.md}px) and (max-width: 991px) {
            flex: 1;
            display: flex;
            justify-content: center;
            min-width: 0;
          }
        }
        & div[data-area-line-slot='right'] {
          @media (min-width: ${theme.breakpoints.md}px) and (max-width: 991px) {
            flex: 0 0 0;
            min-width: 0;
            overflow: hidden;
          }
        }
      `}
  }
`

export const StyledFilterButton = styled(FilterButton)<{
  color?: string
}>`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-right: 24px;
    margin-left: 8px;
  }

  @media (min-width: 992px) {
    flex-shrink: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: calc(100% - 8px) !important;
  }

  & > :first-child {
    ${({ theme, color }) => `
      color: ${color || theme.colors.primary};
      border-color: ${color || theme.colors.primary};
    `};
    background-color: transparent;
  }
`

export const FirstElement = styled.div<{ color?: string }>`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: ${({ color }) => color || '#303032'};
  width: max-content;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin: 10px auto;
    width: 100%;
    text-align: center;
  }

  @media (min-width: 992px) {
    text-align: left;
  }
`

export const CenterWrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin: 8px 0;
  }

  /* Center section slider on medium when right slot is empty (slot gets flex:1 from card). */
  &[data-group-controls-center] {
    @media (min-width: ${({ theme }) =>
        theme.breakpoints.md}px) and (max-width: 991px) {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
`

export const GroupSideButtons = styled.div`
  display: grid;
  grid-template: 40px / minmax(152px, 1fr) repeat(auto-fit, 40px);
  gap: 1rem;
  width: calc(100% + 28px);
  align-self: flex-start;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-left: 8px;
    width: auto;
  }

  @media (min-width: 992px) {
    margin-right: 24px;
  }
`
